import mapboxgl from 'mapbox-gl';

export class ZoomToFitControl implements mapboxgl.IControl {
  private container: HTMLDivElement;
  private button: HTMLButtonElement;
  private boundOnClick: () => void;

  constructor(onClick: () => void) {
    this.boundOnClick = onClick;
    this.container = document.createElement('div');
    this.container.className = 'mapboxgl-ctrl mapboxgl-ctrl-group';

    this.button = document.createElement('button');
    this.button.type = 'button';
    this.button.className = 'mapboxgl-ctrl-geolocate';
    this.button.title = 'Fit all pins';
    this.button.setAttribute('aria-label', 'Fit all pins');

    const icon = document.createElement('span');
    icon.className = 'mapboxgl-ctrl-icon';
    icon.setAttribute('aria-hidden', 'true');
    this.button.append(icon);
    this.button.addEventListener('click', this.boundOnClick);
    this.container.append(this.button);
  }

  onAdd(): HTMLDivElement {
    return this.container;
  }

  onRemove(): void {
    this.button.removeEventListener('click', this.boundOnClick);
    this.container.remove();
  }
}
